import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { ClientAccountClient } from "../../../../../../../../Wrap/Api/Account/ClientAccount";
import { InterestedPartiesClient } from "../../../../../../../../Wrap/Api/Account/InterestedParties";
import { ClientAccessClient } from "../../../../../../../../Wrap/Api/Customer/ClientAccess";
import { ClientAccessesClient } from "../../../../../../../../Wrap/Api/Customer/ClientAccesses";
import { InterestedPartiesByCustomerClient } from "../../../../../../../../Wrap/Api/Customer/InterestedPartiesByCustomer";
import { ReportOptOutSettingsClient } from "../../../../../../../../Wrap/Api/Reports/Settings/ReportOptOutSettings";
import { RoleType } from "../../../../../../../../Wrap/Constants/Enums/RoleType";
import { ClientAccount } from "../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { ClientAccessModel } from "../../../../../../../../Wrap/Models/Models/Customer/ClientAccessModel";
import { OrganisationMember } from "../../../../../../../../Wrap/Models/Models/Customer/OrganisationMember";
import { PortfolioDashboardDisaptcher, PortfolioDashboardStore } from "../../../Store/Variable";
import { updateAccountInfo } from "../../Common/PortfolioDashboardHelper";

export class portfolioDashboardRolesAction {
    public static getInterestedParties(hierarchyIds: Array<string>, callback) {
        const client = new InterestedPartiesClient();
        const promise = client.get(hierarchyIds);
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((err) => console.error(err));
    }

    public static getInterestedPartiesByCustomer(customerId: number, callback) {
        const client = new InterestedPartiesByCustomerClient();
        const promise = client.get(customerId);
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((err) => console.error(err));
    }

    public static getReportOptOutSetting(clAccountId: string, callback) {
        const client = new ReportOptOutSettingsClient();
        const promise = client.get(clAccountId);
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((err) => console.error(err));
    }

    public static getClientAccess(customerId: number, clAccountId: string, roleType: RoleType, callback) {
        const client = new ClientAccessClient();
        const promise = client.get(customerId, clAccountId, roleType);
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((err) => console.error(err));
    }

    public static updateClientAccess(model: ClientAccessModel, callback?) {
        const client = new ClientAccessClient();
        const promise = client.put(model);
        promise.onSuccess((data) => {
            if (callback) {callback(data);}
        });
        promise.onError((err) => console.error(err));
    }

    public static updateClientAccesses(model: OrganisationMember[], hierarchyId: string, callback) {
        const client = new ClientAccessesClient();
        const promise = client.put(model, hierarchyId);
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((err) => console.error(err));
    }

    public static updateReportOptOutSetting(clAccountId: string, optOutContractNote: boolean, callback) {
        const client = new ReportOptOutSettingsClient();
        const promise = client.put(clAccountId, optOutContractNote);
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((err) => console.error(err));
    }

    public static updateClientAccountDetails(
        updatedAccount: ClientAccount,
        dateOfDeath: Date,
        dateOffNotification: Date,
        callback
    ) {
        const client = new ClientAccountClient();
        const promise = client.put(
            updatedAccount,
            JsonDateParser.toJsonDateNoOffset(dateOfDeath),
            JsonDateParser.toJsonDateNoOffset(dateOffNotification)
        );

        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((err) => console.error(err));
    }

    public static updateClientAccountDetailsToStore(updatedAccount: ClientAccount) {
        const newAccounts = updateAccountInfo(updatedAccount, PortfolioDashboardStore.getData());
        PortfolioDashboardDisaptcher.dispatch({ payload: newAccounts, actionType: ActionType.Success });
    }
}
